import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Cooldown & Unstake Window Period',
  description:
    'The cooldown period is {cooldownPeriod}. After the {cooldownPeriod} of cooldown, you will enter the unstake window of {unstakeWindowPeriod}.',
  continueReceiving: 'You will continue receiving rewards during the cooldown and unstake window.',

  infoDescription:
    'If you do not unstake within the 2 days unstake window you will need to activate the cooldown process again',

  cooldownTitle: 'Cooldown period',
  unstakeHere: 'You unstake here',
  unstakeWindowTitle: 'Unstake window',

  checkboxText:
    'I understand how the cooldown ({cooldownPeriod}) and unstaking window ({unstakingWindowPeriod}) work',
  activateCooldown: 'Activate Cooldown',
});
